import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { MasterService } from "../../services";
import Loader from "../common/loader";
import CSVImport from "../common/CSVImportFIle";
import { CSVLink } from 'react-csv';
import { FID_TAGGING_BULK_UPLOAD_FORMAT } from "../../config/constant";
import DateFormat from 'dateformat';

let list = [{ label: "Upload FID Tagging", format: FID_TAGGING_BULK_UPLOAD_FORMAT }]


const FidUsersUpload = (props) => {
    const [modal, setModal] = useState({isOpen:false, data: null});
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState({file:null, name: ''});
    const [fidUploadHistory, setFidUploadHistory] = useState([]);
    const csvLink = useRef();

    useEffect(()=>{
        fetchFidUploadHistory({ loader:true })
    },[])


    const handleFileSelect = (e) => {
        const file = e?.target?.files?.[0];
        setSelectedFile({file, name:file.name});
    };

    const resetFile = () => {
        setSelectedFile({file: null, name: ''});
    };

    const fetchFidUploadHistory = async ({ loader=true }) => {
        if(loader)setLoading(true);
        try {
            let response = await MasterService.post('sfa/user/get_fid_users_history');
            if(loader) setLoading(false);
            if (response.status === 200) {
               setFidUploadHistory(response.data?.data ?? [])
            }
            
        } catch (error) {
            if(loader) setLoading(false);
        }
       
    }

    const handleUpload = async () => {
        if(!selectedFile.file) toast.error('Please select the file')
        setLoading(true);
        try {
            let formData = new FormData();
            formData.append("upload_type", "sfa_docs");
            formData.append("file", selectedFile.file);
            let response = await MasterService.post('sfa/user/upload_fid_users', formData, { 'Content-Type': 'multipart/form-data' });
            setLoading(false);
            if (response.status === 200) {
                fetchFidUploadHistory({ loader:false });
                let { errors, processed } = response.data?.data ?? {};
                if(errors.length){
                    if(processed) toast.success(`Processed records: ${processed}`);
                    toast.error('Validation error');
                    setErrors(errors);
                    resetFile();
                    return
                }
                toast.success('CSV uploaded successfully!')
                handleModalClose();
            }
            
        } catch (error) {
            toast.error(error?.message || "Failed to upload CSV")
            setLoading(false);
        }
       
    }

    const handleModalClose = () => {
        setModal({ isOpen: false, data: null });
        resetFile();
        setErrors([]);
    }

    const handleModalOpen = (data) => {
        setModal({ isOpen: true, data });
    }

    const downloadData = () => {
        csvLink.current.link.click();
      }

    return (
        <React.Fragment>
            {loading ? <Loader /> : null}
            <div className="container-fluid">
                <div className="top-heading d-flex">
                    <h1>FID Tagging Upload</h1>
                </div>
               <div className="fid-upload-container">
                    <ul className="fid-upload-list">
                        { list.map((item, idx)=>( <li key={idx} onClick={()=>handleModalOpen(item)}>{item.label}</li> )) }
                    </ul>
               </div>

                <div className="bulk-upload-popup model-popup-outer">
                    <Modal show={modal.isOpen} handleClose={handleModalClose} >
                        <div>
                            <h3>{modal.data?.label}</h3>
                            <div className="fid-row-wrapper">
                                <div>
                                    <CSVImport
                                        name="fileName"
                                        accept=".csv,.CSV"
                                        onChooseFile={handleFileSelect}
                                        cancelUpload={resetFile}
                                        fileName={selectedFile?.name}
                                    />
                                    <div className="download-txt">
                                        Download FID Tagging Format <span onClick={downloadData}> Click Here</span>
                                    </div>
                                    {modal.isOpen && <CSVLink
                                    data={modal.data?.format}
                                    filename={`fid_tagging_format.csv`}
                                    data-interception='off'
                                    ref={csvLink}
                                    >
                                    </CSVLink>}
                                </div>
                                <div className="user-managemnt-detail-table data-table">
                                    <table>
                                        <thead>
                                            <tr>
                                            <th>Date & Time</th>
                                            <th>Uploaded By</th>
                                            <th>Processed</th>
                                            <th>Failed</th>
                                            <th>Total</th>
                                            <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fidUploadHistory.map((element, index) => (
                                            <tr key={index}>
                                                <td>{DateFormat(element.created_date, 'dd mmm yy, hh:MM TT')}</td>
                                                <td className='show_ellipsis'>{element?.display_name ?? '-'}</td>
                                                <td>{element.processed_count}</td>
                                                <td className={element.error_count > 0 && 'failed_records'}>{element.error_count}</td>
                                                <td>{(element.processed_count + element.error_count) }</td>
                                                <td>
                                                {element.file_url ?
                                                    <ul class="action-btn">
                                                    <li>
                                                        <a href={element.file_url} rel="noreferrer" target="_blank">
                                                        <i class="ic-save_alt"></i>
                                                        </a>
                                                    </li>
                                                    </ul> : ""}
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                               
                                                      
                            </div>
                            <button disabled={!selectedFile.file} onClick={handleUpload} className="btn-primary">Import</button>

                            {errors?.length ? (
                            <div className="fid-error-container">
                                <strong>Row level errors:</strong>
                                <ul className="fid-errorlist">
                                    {errors.map((err, idx) => (
                                        <li key={idx} style={{ borderTop: idx > 0 && '1px solid', padding: '1rem 0', }} >
                                            {`Row No. ${err.row}: `}
                                            {err.errors.map((rowErr, i) => ( <li key={i}>{` - ${rowErr}`}</li>  ))}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                        </div>
                    </Modal>
                </div>


            </div>
        </React.Fragment>)

}

const Modal = ({ handleClose, show, children }) => {
    const showHideClassName = show ? 'modal display-block' : 'modal display-none';

    return (
        <div className={showHideClassName}>
            <section className='modal-main fid-modal'>
                {children}
                <button
                    onClick={handleClose}
                    className="close_icn"
                >
                    <i className="ic-clearclose"></i>
                </button>
            </section>
        </div>
    );
};


export default FidUsersUpload;